import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'dubbingErrorEmptySegments',
  'emptySegmentsDeleteAllClicked',
  'modalDeleteAllEmptySegmentsOpened',
  'bulkVideosDownloadClick',
] as const;

export const projectEvents = getMappedEvents([...EVENTS]);
